<template>
	<el-container id="kebiao">
		<div class="titBox">
			<p class="tit">课程表</p>
			<div class="titRightBox">
				<ul class="qi" :class="$store.state.qiFocus" @click="qiClick">
					<i class="iconfont">&#xe610;</i>
					<li @click.stop="qiClick(0)" :class="qiNum==0?'act':''">全部学期</li>
					<li v-for="(index,i) of qiCount" :key="i" @click.stop="qiClick(index)" :class="qiNum==index?'act':''">第{{qiZh(index)}}学期{{"（"+kaixue(index, qiDang)+"）"}}</li>
				</ul>
			</div>
			<div class="class_time" v-if="schedules_obj[qiNum]">上课时间：{{schedules_obj_txt(schedules_obj[qiNum])}}</div>
		</div>
		<div class="kebiaoBox">
			<el-table :data="tableData" header-row-class-name="kbHead" stripe class="kebiaoTab" v-loading="loading" :cell-class-name="tdClass">
				<el-table-column prop="course_title" class-name="title" label="课程名称"></el-table-column>
				<!-- <el-table-column prop="course_code" align="center" label="课程代码" width="130"></el-table-column> -->
				<el-table-column prop="study_score" align="center" label="学分" width="100"></el-table-column>
				<el-table-column prop="study_time2" align="center" label="学时" width="100"></el-table-column>
				<el-table-column prop="jindu" align="center" label="学习进度" width="180" :formatter="jinduCon"></el-table-column>
				<el-table-column prop="termTxt" class-name="qi" align="right" label="开课学期" width="180"></el-table-column>
			</el-table>
			<div class="nodata" v-if="!tableData">
				<img :src="nodataImg">
				<p>暂无内容</p>
			</div>
		</div>
	</el-container>
</template>

<script>
//获取课程表
function getKebiao(that, term){
	var token=that.$cookies.get("token")
		,serverSrc=that.global.serverSrc
		,qianzui=that.global.qianzui;

	that.$ajax.get(serverSrc + qianzui + "/member/courses",{
		params:{
			term:term
			,pagsize:999
		}
	})
	.then(function(res){
		let resData=res.data
			,kbArr=[]
		if(resData.code==0){
			let kbData=resData.data.data
			for(let k=0;k<kbData.length;k++){
				kbArr.push({
					course_title:kbData[k].course.title
					,course_code:kbData[k].course_code
					,study_score:kbData[k].study_score
					,study_time2:kbData[k].study_time2
					,jindu:[kbData[k].course_program,
						kbData[k].course_chapter_count,
						that.classChapter(parseInt(kbData[k].total_score), kbData[k].total)
					]
					,termTxt:'第'+that.qiZh(kbData[k].term)+'学期'
				})
			}
			that.tableData=kbArr
			that.loading=false;
		}else{
			that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
		}
	})
}
export default {
	name: 'kebiao'
	,data () {
		return {
			qiNum:0
			,qiDang:0
			,qiCount:0
			,loading:true
			,tableData:[]
			,schedules_obj:{}
		}
	}
	,mounted:function(){
		var that=this

		//获取用户数据
		this.$selfjs.getUserCallFn(this,function(res){
			that.qiDang = res.term				//当前学期
			that.qiNum = res.term				//现在选择的学期数
			that.qiCount = res.term_count		//学期数
			for (let i = 0; i < res.grade.schedules.length; i++) {
				let obj = res.grade.schedules[i]
				that.schedules_obj[obj.term] = obj
			}
			that.loading=false;
			//获取课程表
			getKebiao(that, res.term)
		})
	}
	,methods:{
		//学习时间
		schedules_obj_txt(obj){
			return obj.start_date.replace(/-/g,'.') + ' - ' +obj.end_date.replace(/-/g,'.')
		},
		jinduCon(row, column, cellValue, index){
			// console.log(cellValue)
			if(cellValue[2]){
				return cellValue[2];
			}
		},
		tdClass(obj){
			if(obj.column.property=="jindu"){
				let start = obj.row.jindu[0]
					,end = obj.row.jindu[1]
				if(start == 0){
					return "daixue";
				}else if(start == end){
					return "yiwan";
				}else{
					return "yixue"
				}
			}
		},
		//课程进度计算
		classChapter(start, end){
			if(start == 0){
				return "待学习";
			}else if(start == end){
				return "已完成";
			}else{
				return "已学"+parseInt((start/end)*100)+"%"
			}
		},
		//学期中文字返回
		qiZh(i){
			return this.$selfjs.qiZh(i)
		},
		//学期是否已开学
		kaixue(i, dang){
			if(i==dang){
				return '当前学期'
			}else if(i>dang){
				return '未开学'
			}else if(i<dang){
				return '已完成学期'
			}
		},
		//学期选择点击
		qiClick(num){
			var that=this
			this.$selfjs.qiSelect(this,{num:num}, function(option){
				that.qiNum=option.num
				that.loading=true
				// if (num) {
				// 	if (num>that.qiDang) {
				// 		that.$message.warning('课程未到学习时间');
				// 	}else if (num<that.qiDang) {
				// 		that.$message.warning('课程已过学习时间');
				// 	}
				// }
				
				//获取课程表
				getKebiao(that, num)
			})
		}
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/renwu/kebiao.vue